export const usmle1ModuleOverview = [
  {
    id: "biochem",
    title: "Biochemistry",
    description: "Pathways, enzymes, and inheritance patterns.",
    icon: "🧪",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "genetics",
    title: "Genetics",
    description: "Chromosomal disorders and pedigrees.",
    icon: "🧬",
    gradient: "from-violet-100 via-purple-50 to-indigo-100 border-violet-300",
  },
  {
    id: "micro",
    title: "Microbiology",
    description: "Bacteria, viruses, fungi, parasites.",
    icon: "🦠",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-300",
  },
  {
    id: "immunology",
    title: "Immunology",
    description: "Innate/adaptive and hypersensitivity.",
    icon: "🛡️",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "pharm",
    title: "Pharmacology",
    description: "Mechanisms, side effects, antidotes.",
    icon: "💊",
    gradient: "from-pink-100 via-rose-50 to-fuchsia-100 border-pink-300",
  },
  {
    id: "path",
    title: "Pathology",
    description: "Core disease patterns and buzzwords.",
    icon: "🔬",
    gradient: "from-red-100 via-rose-50 to-pink-100 border-red-300",
  },
  {
    id: "physio",
    title: "Physiology",
    description: "Systems-based physiology essentials.",
    icon: "⚡",
    gradient: "from-lime-100 via-green-50 to-emerald-100 border-lime-300",
  },
  {
    id: "biostats",
    title: "Biostatistics",
    description: "Study design, tests, and interpretation.",
    icon: "📊",
    gradient: "from-slate-100 via-gray-50 to-zinc-100 border-slate-300",
  },
];
